import INVOICE_WIDGETS from "@/configuration/widgets/INVOICE_WIDGETS";
import i18n from "@/language/i18n";

const INVOICE_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    PAYMENTS_MODULE_WINDOW_ID: 'payments',
    SMART_CONTROLLING_MODULE_WINDOW_ID: 'smartcontrolling',
});

export { INVOICE_MODULE_WINDOW_IDENTIFIER };

export default {
    INVOICE_GROUP_WRAPPER: {
        type: 'group',
        id: 'invoices',
        label: i18n.t('ModuleRegistry.groups.invoices.name'),
        children: [],
        icon: '$wCall',
        sidebarIcon: '$wNavInvoice'
    },
    CHILDREN: {
        PAYMENTS_MODULE: {
            type: 'module',
            id: 'payments',
            windowIdentifierType: INVOICE_MODULE_WINDOW_IDENTIFIER.PAYMENTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.invoices.payments.label'),
            navigationImg: require('@/assets/navigation/items/icon_krankmeldung.svg'),
            routerLink: '/payments',
            widgets: INVOICE_WIDGETS.INVOICE_WIDGETS
        },
        SMART_CONTROLLING_MODULE: {
            type: 'module',
            id: 'smartcontrolling',
            windowIdentifierType: INVOICE_MODULE_WINDOW_IDENTIFIER.SMART_CONTROLLING_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.invoices.smartControlling.label'),
            navigationImg: require('@/assets/navigation/items/icon_krankmeldung.svg'),
            routerLink: '/smartcontrolling',
            widgets: []
        },
    }
}
